import { render, staticRenderFns } from "./myDialog.vue?vue&type=template&id=f8d436a4"
import script from "./myDialog.vue?vue&type=script&lang=js"
export * from "./myDialog.vue?vue&type=script&lang=js"
import style0 from "./myDialog.vue?vue&type=style&index=0&id=f8d436a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports